export const AUTH_QUICK_LOGIN_PROFILE_NOT_ELIGIBLE = 'AUTH_QUICK_LOGIN_PROFILE_NOT_ELIGIBLE';
export const AUTH_QUICK_LOGIN_PIN_NOT_SET = 'AUTH_QUICK_LOGIN_PIN_NOT_SET';
export const AUTH_QUICK_LOGIN_PIN_INVALID = 'AUTH_QUICK_LOGIN_PIN_INVALID';
export const AUTH_QUICK_LOGIN_PIN_LOCKED = 'AUTH_QUICK_LOGIN_PIN_LOCKED';
export const AUTH_QUICK_LOGIN_STEP_UP_REQUIRED = 'AUTH_QUICK_LOGIN_STEP_UP_REQUIRED';
export const AUTH_QUICK_LOGIN_STEP_UP_INVALID = 'AUTH_QUICK_LOGIN_STEP_UP_INVALID';
export const AUTH_QUICK_LOGIN_PASSWORD_VERIFIER_MISSING = 'AUTH_QUICK_LOGIN_PASSWORD_VERIFIER_MISSING';
export const AUTH_QUICK_LOGIN_PIN_POLICY_VIOLATION = 'AUTH_QUICK_LOGIN_PIN_POLICY_VIOLATION';
export const AUTH_QUICK_LOGIN_ADMIN_REQUIRED = 'AUTH_QUICK_LOGIN_ADMIN_REQUIRED';
export const AUTH_QUICK_LOGIN_CURRENT_PIN_REQUIRED = 'AUTH_QUICK_LOGIN_CURRENT_PIN_REQUIRED';

export const quickLoginErrorCodes = [
  AUTH_QUICK_LOGIN_PROFILE_NOT_ELIGIBLE,
  AUTH_QUICK_LOGIN_PIN_NOT_SET,
  AUTH_QUICK_LOGIN_PIN_INVALID,
  AUTH_QUICK_LOGIN_PIN_LOCKED,
  AUTH_QUICK_LOGIN_STEP_UP_REQUIRED,
  AUTH_QUICK_LOGIN_STEP_UP_INVALID,
  AUTH_QUICK_LOGIN_PASSWORD_VERIFIER_MISSING,
  AUTH_QUICK_LOGIN_PIN_POLICY_VIOLATION,
  AUTH_QUICK_LOGIN_ADMIN_REQUIRED,
  AUTH_QUICK_LOGIN_CURRENT_PIN_REQUIRED,
] as const;

export type QuickLoginErrorCode = (typeof quickLoginErrorCodes)[number];
